export default (theme) => {
  return `
  .mu-divider {
    background-color: ${theme.divider};
  }
  `;
};



// WEBPACK FOOTER //
// ./src/muse-ui/Divider/theme.js